import { createContext, useContext, useMemo, useState } from "react"
const ContextsCompetence = createContext()

/**
 * Proveedor de contexto para el plan anual.
 *
 * @param {Object} props
 * @param {React.ReactNode} props.children - Componentes hijos.
 */
export function ContextsCompetenceProvider({ children }) {
	const [reload, setReload] = useState(true)
	const [competence, setCompetence] = useState({})
	const datos = useMemo(
		() => ({
			reload,
			refresh: () => setReload(!reload),
			competence,
			setCompetence,
		}),
		[competence, reload]
	)
	return (
		<ContextsCompetence.Provider value={datos}>{children}</ContextsCompetence.Provider>
	)
}

/**
 * @typedef {Object} CompetenceContextParams
 * @property {boolean} reload - Indica si se debe recargar.
 * @property {function():void} refresh - actualiza el reload
 * @property {CompetenceParams} competence - la competencia.
 * @property {function():void} setCompetence - la competencia.
 */

/**
 * Hook para acceder al contexto de creación del plan anual.
 * @returns {CompetenceContextParams}
 */
export function UseContextsCompetence() {
	return useContext(ContextsCompetence)
}
